export default __webpack_public_path__ + "static/media/hardware_module.ddb3f1ee.png";